import { Controller } from "@hotwired/stimulus"
import Modal from "bootstrap/js/dist/modal"

export default class extends Controller {
  static targets = ["modal", "image"]

  connect() {
    this.modal = new Modal(this.modalTarget)
  }

  open(event) {
    event.preventDefault()
    const imageUrl = event.currentTarget.dataset.imageModalUrlParam
    this.imageTarget.src = imageUrl
    this.modal.show()
  }
}
